import {
  ListProOpenJobCountsRequest,
  GetJobTotalsRequest,
  GetJobTotalsResponse,
  GetJobTotalStatusAggregationsResponse,
  GetJobTotalStatusAggregationsRequest,
} from '@taxfyle/api-internal/internal/job_stats_pb'

import { collection } from 'infra/collection'
import { Id } from 'types/definitions'
import { JobStatsAPI } from './API'
import {
  JobTotalsDTO,
  JobTotalStatusAggregationsDTO,
  ProOpenJobCountDTO,
} from './dtos'
import { ProOpenJobCount } from './ProOpenJobCount'

export default class JobStatsStore {
  proOpenJobCounts = collection<ProOpenJobCountDTO, ProOpenJobCount>({
    create: () => new ProOpenJobCount(),
    getDataId: (data) => data.workspaceId,
    getModelId: (model) => model.workspaceId,
  })

  constructor(private api: JobStatsAPI) {
    this.listProOpenJobCounts = this.listProOpenJobCounts.bind(this)
    this.getJobTotals = this.getJobTotals.bind(this)
  }

  async listProOpenJobCounts(userPublicId: Id) {
    const result = await this.api.listProOpenJobCounts(
      new ListProOpenJobCountsRequest().setUserId(Id.assert(userPublicId)),
    )

    const proOpenJobCounts = result
      .getProOpenJobCountsList()
      .map((dto) => dto.toObject())

    return this.proOpenJobCounts.set(proOpenJobCounts)
  }

  async getJobTotals(userPublicId: Id) {
    const toDto = (response: GetJobTotalsResponse): JobTotalsDTO => {
      return {
        actives: response.getActives(),
        total: response.getTotal(),
      }
    }

    return this.api
      .getJobTotals(
        new GetJobTotalsRequest().setUserId(Id.assert(userPublicId)),
      )
      .then(toDto)
  }

  async getJobTotalStatusAggregations(userPublicId: Id, workspaceId: Id) {
    const toDto = (
      response: GetJobTotalStatusAggregationsResponse,
    ): JobTotalStatusAggregationsDTO => {
      return {
        infoGathering: response.getInfoGathering(),
        closed: response.getClosed(),
        idle: response.getIdle(),
        onHold: response.getOnHold(),
        unclaimed: response.getUnclaimed(),
        claimed: response.getClaimed(),
        underConstruction: response.getUnderConstruction(),
      }
    }

    return this.api
      .getJobTotalStatusAggregations(
        new GetJobTotalStatusAggregationsRequest()
          .setUserId(Id.assert(userPublicId))
          .setWorkspaceId(Id.assert(workspaceId)),
      )
      .then(toDto)
  }
}
